export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";